import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout";
import OverviewPage from "../pages/OverviewPage";
import HealthRecordsPage from "../pages/HealthRecordsPage";
import AdminAnalyticsPage from "../pages/AdminAnalyticsPage";
import PetIdentificationPage from "../pages/PetIdentificationPage";
import MyPetsPage from "../pages/MyPetsPage";
import RegisterPetPage from "../pages/RegisterPetPage";
import BreedDatabasePage from "../pages/BreedDatabasePage";
import SettingsPage from "../pages/SettingsPage";
import VaccinationRecordsPage from "../pages/VaccinationRecordsPage";
import VeterinarianDashboardPage from "../pages/VeterinarianDashboardPage";
import SystemArchitecturePage from "../pages/SystemArchitecturePage";
import LostDogsPage from "../pages/LostDogsPage";
import RegisterLostDogPage from "../pages/RegisterLostDogPage";
import FoundPetPage from "../pages/FoundPetPage";
import VeterinaryPriceComparisonPage from "../pages/VeterinaryPriceComparisonPage";

// Import existing working components
import DogBreedDetector from "./DogBreedDetector";
import BreedInfo from "./BreedInfo";
import ApiKeyManager from "./ApiKeyManager";
import ApiDocumentationDetailed from "./ApiDocumentationDetailed";
import BusinessPlanPage from "./BusinessPlanPage";

// All functionality now implemented in dedicated page components

const DashboardRouter = ({ user, userRole, isLoadingUserRole }) => {
  return (
    <DashboardLayout
      user={user}
      userRole={userRole}
      isLoadingUserRole={isLoadingUserRole}
    >
      <Routes>
        {/* Default route - Overview */}
        <Route
          path="/"
          element={<OverviewPage user={user} userRole={userRole} />}
        />

        {/* Main pages */}
        <Route path="/identify" element={<PetIdentificationPage />} />
        <Route path="/dog-breed" element={<DogBreedDetector user={user} />} />
        <Route path="/breed-info" element={<BreedInfo />} />
        <Route
          path="/breed-database"
          element={<BreedDatabasePage userRole={userRole} />}
        />
        <Route path="/pets" element={<MyPetsPage user={user} />} />
        <Route path="/register" element={<RegisterPetPage user={user} />} />

        {/* Vaccination Records - Pro/Admin only */}
        <Route
          path="/vaccinations"
          element={
            userRole === "pro" || userRole === "admin" ? (
              <VaccinationRecordsPage user={user} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* Pro/Admin only pages */}
        <Route
          path="/health"
          element={
            userRole === "pro" || userRole === "admin" ? (
              <HealthRecordsPage user={user} userRole={userRole} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/api-keys"
          element={
            userRole === "pro" || userRole === "admin" ? (
              <ApiKeyManager user={user} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/api/detailed"
          element={
            userRole === "pro" || userRole === "admin" ? (
              <ApiDocumentationDetailed />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* Admin only pages */}
        <Route
          path="/analytics"
          element={
            userRole === "admin" ? (
              <AdminAnalyticsPage user={user} userRole={userRole} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/business-plan"
          element={(() => {
            console.log("Business plan route accessed, userRole:", userRole);
            return userRole === "admin" ? (
              <BusinessPlanPage user={user} userRole={userRole} />
            ) : (
              <Navigate to="/" replace />
            );
          })()}
        />
        <Route
          path="/vet-dashboard"
          element={(() => {
            console.log("Vet dashboard route accessed, userRole:", userRole);
            return userRole === "admin" ? (
              <VeterinarianDashboardPage user={user} userRole={userRole} />
            ) : (
              <Navigate to="/" replace />
            );
          })()}
        />
        <Route
          path="/system-architecture"
          element={(() => {
            console.log(
              "System architecture route accessed, userRole:",
              userRole
            );
            return userRole === "admin" ? (
              <SystemArchitecturePage user={user} userRole={userRole} />
            ) : (
              <Navigate to="/" replace />
            );
          })()}
        />

        {/* Settings */}
        <Route
          path="/settings"
          element={<SettingsPage user={user} userRole={userRole} />}
        />

        {/* Lost & Found pages */}
        <Route path="/lost-dogs" element={<LostDogsPage user={user} />} />
        <Route
          path="/register-lost-dog"
          element={<RegisterLostDogPage user={user} />}
        />
        <Route path="/found-pet" element={<FoundPetPage user={user} />} />

        {/* Veterinary Services - snute.io inspired */}
        <Route
          path="/vet-prices"
          element={<VeterinaryPriceComparisonPage user={user} />}
        />

        {/* Catch all - redirect to overview */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardRouter;
